import { render, staticRenderFns } from "./CallButtons.vue?vue&type=template&id=1ee99ea1"
import script from "./CallButtons.vue?vue&type=script&lang=js"
export * from "./CallButtons.vue?vue&type=script&lang=js"
import style0 from "./CallButtons.vue?vue&type=style&index=0&id=1ee99ea1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports